import React from 'react';

export const Risks = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.767822"
      width="48"
      height="48"
      rx="24"
      fill={color ? 'none' : '#FFEBE6'}
    />
    <path
      d="M23.5601 17.3596C23.7494 17.0109 24.2498 17.0109 24.439 17.3596L32.4003 32.0293C32.5811 32.3624 32.3399 32.7678 31.9609 32.7678H16.0383C15.6592 32.7678 15.418 32.3624 15.5988 32.0293L23.5601 17.3596Z"
      stroke={color ? color : '#FF5630'}
      strokeWidth="2"
    />
    <path
      d="M25 22.8108C25 22.2585 24.5523 21.8108 24 21.8108C23.4477 21.8108 23 22.2585 23 22.8108H25ZM23 26.172C23 26.7243 23.4477 27.172 24 27.172C24.5523 27.172 25 26.7243 25 26.172H23ZM23 22.8108V26.172H25V22.8108H23Z"
      fill={color ? color : '#FF5630'}
    />
    <circle
      cx="24.0003"
      cy="29.3526"
      r="1.34702"
      fill={color ? color : '#FF5630'}
    />
  </svg>
);
